import { SECTIONS, SECTION_KEYS, daysUntil, phrase, searchText, tone } from './model'
import type { RegisterData, SectionKey } from './model'
import { Pill } from './ui'

const s = (v: unknown) => (v == null ? '' : String(v))

export function Search({
  data,
  query,
  onOpen,
}: {
  data: RegisterData
  query: string
  onOpen: (section: SectionKey, id: string) => void
}) {
  const q = query.trim().toLowerCase()
  const groups = SECTION_KEYS.map((key) => {
    const sec = SECTIONS[key]
    const hits = data[key].filter((r) => searchText(r).includes(q))
    return { key, sec, hits }
  }).filter((g) => g.hits.length)

  const total = groups.reduce((n, g) => n + g.hits.length, 0)

  if (!total) {
    return <p className="empty">Nothing matches “{query}”.</p>
  }

  return (
    <>
      {groups.map(({ key, sec, hits }) => (
        <div className="res" key={key}>
          <h4>
            {sec.label} · {hits.length}
          </h4>
          {hits.slice(0, 8).map((r) => {
            const n = sec.dateField ? daysUntil(r[sec.dateField]) : null
            return (
              <button
                type="button"
                className="row"
                key={s(r.id)}
                onClick={() => onOpen(key, s(r.id))}
              >
                <div className="main">
                  <div className="t">{s(r[sec.titleField]) || 'Untitled'}</div>
                  <div className="m">{sec.meta(r) || ' '}</div>
                </div>
                {sec.dateField && <Pill tone={tone(n)}>{phrase(n)}</Pill>}
              </button>
            )
          })}
          {hits.length > 8 && (
            <p className="k" style={{ margin: '8px 0 0' }}>
              +{hits.length - 8} more — open {sec.label} to see them all
            </p>
          )}
        </div>
      ))}
    </>
  )
}
